import type { MegaMenuVisualSelectorConfig } from '#types/config/components/cms/mega-menu-visual-selector'

export default {
  imageSize: '64',
} satisfies MegaMenuVisualSelectorConfig
